'use client';

import Link from 'next/link';
import MarketingHeader from '@/components/MarketingHeader';
import MarketingFooter from '@/components/MarketingFooter';
import { getBrandHomeUrl } from '@/lib/creatorPlatformUrls';
import { OFFICIAL_CONTACT_EMAIL } from '@/lib/officialContact';

export default function ContactPage() {
  return (
    <div className="home-page">
      <MarketingHeader />
      <main className="about-main">
        <h1 className="home-about-title">联系我们</h1>
        <p className="home-about-text about-main-contact-intro">
          商务合作与业务咨询，欢迎通过以下方式与我们取得联系。
        </p>
        <p className="home-about-text">邮箱：{OFFICIAL_CONTACT_EMAIL}</p>
        <p style={{ marginTop: '4rem', fontSize: '0.875rem' }}>
          <Link href={getBrandHomeUrl()} className="link-hover">&lt; 返回首页</Link>
        </p>
      </main>
      <MarketingFooter />
    </div>
  );
}
